import clsx from 'clsx';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
}

const SIZE_CLASS: Record<NonNullable<LoadingSpinnerProps['size']>, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-10 w-10 border-4',
};

export function LoadingSpinner({ size = 'md', className, label }: LoadingSpinnerProps): JSX.Element {
  return (
    <span
      role="status"
      aria-live="polite"
      aria-label={label ?? 'Cargando'}
      className={clsx('inline-flex items-center gap-2 text-slate-500', className)}
    >
      <span
        className={clsx(
          'animate-spin rounded-full border-slate-300 border-t-primary',
          SIZE_CLASS[size],
        )}
      />
      {label !== undefined ? <span className="text-sm">{label}</span> : null}
    </span>
  );
}
